import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { Button, WHATSAPP_URL } from './ui/Button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Resultados',
    href: '#resultados'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.16, 1, 0.3, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-softwhite/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-138">
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-139">
        {/* Logo */}
        <a href="#" className="flex flex-col items-center group" data-id="element-140">
          <span className="font-serif text-2xl md:text-3xl tracking-wider text-deepblack group-hover:text-rosegold transition-colors" data-id="element-141">
            AURA
          </span>
          <span className="font-sans text-[0.5rem] md:text-xs tracking-[0.3em] text-mauve font-light" data-id="element-142">
            ESTÉTICA
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-143">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-sans text-deepblack/80 hover:text-rosegold transition-colors uppercase tracking-widest" data-id="element-144">
              {link.name}
            </a>)}
        </nav>

        {/* CTA Button */}
        <div className="hidden md:block" data-id="element-145">
          <Button href={WHATSAPP_URL} size="sm" data-id="element-146">
            Reservar Turno
          </Button>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-deepblack p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-147">
          {isMobileMenuOpen ? <X size={24} data-id="element-148" /> : <Menu size={24} data-id="element-149" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-150">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-softwhite border-t border-nude-dark overflow-hidden" data-id="element-151">
            <div className="container mx-auto px-6 py-8 flex flex-col gap-6" data-id="element-152">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-lg font-serif text-deepblack hover:text-rosegold transition-colors" data-id="element-153">
                  {link.name}
                </a>)}
              <div className="pt-4 border-t border-nude-dark" data-id="element-154">
                <Button href={WHATSAPP_URL} className="w-full" data-id="element-155">
                  Reservar Turno
                </Button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.header>;
}